"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var OFFERING_TYPES = {
  EXPSTD: 'Expense - Standard',
  EXPPRO: 'Expense - Professional',
  INVSTD: 'Invoice - Standard',
  INVPRO: 'Invoice - Professional',
  TRVSTD: 'Travel - Standard',
  TRVPRO: 'Travel - Professional',
  TRQPRO: 'Travel Request - Professional',
  TRIPLINK: 'TripLink'
};
var _default = exports.default = OFFERING_TYPES;